var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfExcel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    rx: 8,
    transform: "rotate(180 40 40)",
    fill: "#C5EEDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 18.7059C13 15.5447 13 13.9641 13.9958 12.9821C14.9917 12 16.5944 12 19.8 12H23.2C26.4056 12 28.0083 12 29.0042 12.9821C30 13.9641 30 15.5447 30 18.7059V24.2941C30 27.4553 30 29.0359 29.0042 30.0179C28.0083 31 26.4056 31 23.2 31H19.8C16.5944 31 14.9917 31 13.9958 30.0179C13 29.0359 13 27.4553 13 24.2941V18.7059Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 18.5C27 18.9659 27 19.1989 26.9163 19.3827C26.8046 19.6277 26.5905 19.8224 26.321 19.9239C26.1188 20 25.8625 20 25.35 20H17.65C17.1375 20 16.8812 20 16.679 19.9239C16.4095 19.8224 16.1954 19.6277 16.0837 19.3827C16 19.1989 16 18.9659 16 18.5C16 18.0341 16 17.8011 16.0837 17.6173C16.1954 17.3723 16.4095 17.1776 16.679 17.0761C16.8812 17 17.1375 17 17.65 17H25.35C25.8625 17 26.1188 17 26.321 17.0761C26.5905 17.1776 26.8046 17.3723 26.9163 17.6173C27 17.8011 27 18.0341 27 18.5Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.5C27 21.9659 27 22.1989 26.9163 22.3827C26.8046 22.6277 26.5905 22.8224 26.321 22.9239C26.1188 23 25.8625 23 25.35 23H17.65C17.1375 23 16.8812 23 16.679 22.9239C16.4095 22.8224 16.1954 22.6277 16.0837 22.3827C16 22.1989 16 21.9659 16 21.5C16 21.0341 16 20.8011 16.0837 20.6173C16.1954 20.3723 16.4095 20.1776 16.679 20.0761C16.8812 20 17.1375 20 17.65 20H25.35C25.8625 20 26.1188 20 26.321 20.0761C26.5905 20.1776 26.8046 20.3723 26.9163 20.6173C27 20.8011 27 21.0341 27 21.5Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24.5C27 24.9659 27 25.1989 26.9163 25.3827C26.8046 25.6277 26.5905 25.8224 26.321 25.9239C26.1188 26 25.8625 26 25.35 26H17.65C17.1375 26 16.8812 26 16.679 25.9239C16.4095 25.8224 16.1954 25.6277 16.0837 25.3827C16 25.1989 16 24.9659 16 24.5C16 24.0341 16 23.8011 16.0837 23.6173C16.1954 23.3723 16.4095 23.1776 16.679 23.0761C16.8812 23 17.1375 23 17.65 23H25.35C25.8625 23 26.1188 23 26.321 23.0761C26.5905 23.1776 26.8046 23.3723 26.9163 23.6173C27 23.8011 27 24.0341 27 24.5Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 28C11.5222 28 10 26.4988 10 24.6471V17.9412C10 13.7263 10 11.6188 11.3278 10.3094C12.6556 9 14.7926 9 19.0667 9H23.6C25.4778 9 27 10.5012 27 12.3529",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfExcel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf-excel.f08334ed2203e959f135c277b3c5a54f.svg";